import * as yup from 'yup';

export const PolygonFeatureSchema = yup.object({
  coordinates: yup
    .array(
      yup
        .array(
          yup.tuple([yup.number().defined(), yup.number().defined()]).defined(),
        )
        .defined(),
    )
    .defined(),
  type: yup.string().oneOf(['Polygon']).defined(),
});

export type PolygonGeoJsonFeature = yup.InferType<typeof PolygonFeatureSchema>;

export const PointFeatureSchema = yup.object({
  coordinates: yup
    .tuple([yup.number().defined(), yup.number().defined()])
    .defined(),
  type: yup.string().oneOf(['Point']).defined(),
});

export type PointGeoJsonFeature = yup.InferType<typeof PointFeatureSchema>;

export const GeoJsonFeatureSchema = yup.lazy((_geom: unknown) => {
  const isPointSchena = yup
    .object({
      type: yup.string().oneOf(['Point']).defined(),
    })
    .isValidSync(_geom, { stripUnknown: true });

  return isPointSchena
    ? PointFeatureSchema.defined()
    : PolygonFeatureSchema.defined();
});

export type GeoJsonFeature = yup.InferType<typeof GeoJsonFeatureSchema>;
